/**
 * environment para entorno de desarrollo
 *
 * Para compilar: ng build --configuration=entornoDev
 *
 */
import { Environment } from '../shared/types/auth.types';

export const environment: Environment = {
  version: '2.1.0',
  production: false,
  environmentName: 'Desarrollo',

  /**
   * URL base de la aplicación
   */
  appUrl: 'https://dev-inventario.ieeg.mx/',

  /**
   * Endpoint base de tu API.
   *
   * Esto se usa para apuntar a tus servicios en backend.
   */
  apiUrl: 'https://eoqwaw8c2h.execute-api.us-east-1.amazonaws.com/Prod/api',

  /**
   * Endpoint base de tu API para S3.
   */
  apiS3Url: 'https://eoqwaw8c2h.execute-api.us-east-1.amazonaws.com/Prod/api',

  /**
   * Endpoint base de tu API para autenticación.
   */
  apiAuthUrl: 'https://auth.ieeg.mx/api',

  /**
   * Endpoint para la API de eFirma
   */
  eFirmaApiUrl: 'https://w0stjbc4bi.execute-api.us-east-1.amazonaws.com/Dev/v1',

  /**
   * Endpoint para notificar el resultado de la firma
   */
  callbackUrl:
    'https://3iaqwib8qg.execute-api.us-east-1.amazonaws.com/Prod/api/firma/documento',

  /**
   * ID del sistema para autenticación.
   */
  systemId: '14',

  /**
   * Configuración para datos simulados y funcionalidades de desarrollo
   */
  development: {
    useMockData: true, // Usar datos simulados en lugar de llamadas a la API
    enableRefreshToken: true, // Activar/desactivar llamadas automáticas a RefreshToken
  },

  /**
   * Azure AD - MSAL
   * Ajusta estos valores a los que te provea tu tenat de Azure.
   */
  azure: {
    clientId: 'f12da181-5016-4bd1-8972-9eecc2fc2ba2',
    tenantId: '6d88d07c-1672-4d16-ab8c-3af2ef736fe7',
    // redirectUri: 'http://localhost:4200',
    redirectUri: 'https://dev-inventario.ieeg.mx/',
    scopes: ['api://b8d13544-79e3-4dc7-8a31-5dc2ac2713aa/Auth.AD'],
    me: 'https://graph.microsoft.com/v1.0/me',
  },

  // Token clavado para pruebas
  token:
    'SIMULATE numero_empleado:12345;id_usuario:67890;roles=admin,group_admin;name=Lucia;id_sistema=24',
  refreshToken: 'LpFcK0zSIEWRlw4LOTc5bw==',
};
